<div class="popup-wrapper_1">
  <div class="close-btn">
    <i class="material-icons" (click)="handleCloseAndSendEvent('cancel')">close</i>
  </div>
  <div class="top-img-wrapper">
    <img loading="lazy" [attr.data-src]="'/assets/images/share_love.png'" alt="hands image" />
  </div>
  <div class="content">
    <div class="title">
      There's another way of helping {{fundraiser?.beneficiaryname?.info_1?.split(' ', 2)[0]}}
    </div>
    <div class="description">Tell your friends and family about this fundraiser.</div>
  </div>
  <div class="action-wrapper">
    <app-button label="Donate Now" btnClass="full-width" (click)="handleCloseAndSendEvent('help')"></app-button>
    <app-whatsapp-share *ngIf="currency === 'INR'" label="Share via WhatsApp" [fundraiser]="fundraiser" [basicInfo]="fundraiser?.basicInfo" [isFundraiserEnded]="isFundraiserEnded"></app-whatsapp-share>
    <app-fb-share [backgroudColor]="'#1877F2'" *ngIf="currency !== 'INR'" label="Share via Facebook"></app-fb-share>
  </div>
</div>